import classNames from 'classnames';
import { PropertyWizardContext } from 'context/Context';
import { Field, Form, Formik } from 'formik';
import lodash from 'lodash';
import { useContext, useEffect, useState } from 'react';
import { Col, Collapse, OverlayTrigger, Row, Tooltip } from 'react-bootstrap';
import { FiInfo, FiMapPin } from 'react-icons/fi';
import { useSelector } from 'react-redux';
import { LocationSchema } from '../../validations/propertiesValidation';
import GoogleMap from './utils/GoogleMap';
import InputAddressAutocomplete from './utils/InputAutocomplete';
import { CheckErrors } from 'utils/CheckErrors';
import ReactSelect from 'react-select';

const Ubicacion = () => {
  const { data, handleSubmit, setStepStatus, yupSubmitRef } = useContext(
    PropertyWizardContext
  );

  const { neighborhoods, neighborhoodsObj } = useSelector(state => state.props);

  const [currentNeighborhood, setCurrentNeighborhood] = useState({});
  const [mobileGoogle, setMobileGoogle] = useState(false); // para hacer mobile el googlemaps
  const [ready, setReady] = useState(false);
  const [emptyInput, setEmptyInput] = useState(false);

  const initialValues = {
    street: data.location?.street || '',
    number: data.location?.number || '',
    barrios: data.location?.barrios || '',
    lat: data.location?.lat || '',
    lng: data.location?.lng || '',
    cp: data.location?.cp || '',
    cp_suffix: data.location?.cp_suffix || '',
    area_level_1: data.location?.area_level_1 || '',
    area_level_2: data.location?.area_level_2 || '',
    locality: data.location?.locality || '',
    letter: data.location?.letter || ''
  };

  return (
    <>
      {data && (
        <>
          <h4 className="my-4">
            <FiMapPin /> Agregá la Ubicación.
            <OverlayTrigger
              overlay={
                <Tooltip id={`tooltip-top`} className="small">
                  Recordá que el inmueble debe estar ubicado en CABA.
                </Tooltip>
              }
            >
              <span>
                <FiInfo className="ms-2" size={16} />
              </span>
            </OverlayTrigger>
          </h4>
          <Formik
            initialValues={initialValues}
            validationSchema={LocationSchema}
            onSubmit={values =>
              handleSubmit(
                {
                  location: { ...values }
                },
                lodash.isEqual(values, initialValues)
              )
            }
          >
            {({ errors, setValues, values }) => {
              const handleClick = () => {
                console.log('errors', errors);
                CheckErrors(errors);
              };
              useEffect(async () => {
                setStepStatus(prev => ({
                  ...prev,
                  location: { ...values }
                }));

                if (values.barrios && values.barrios[0]) {
                  setCurrentNeighborhood(
                    neighborhoods.find(n => n.value === values.barrios[0])
                  );
                } else {
                  setCurrentNeighborhood({});
                }
              }, [values, neighborhoods]);

              return (
                <Form
                  className="contact_form profile mb30"
                  onKeyDown={e => {
                    e.key === 'Enter' && e.preventDefault();
                  }}
                >
                  <Row>
                    <Col xs={12} sm={12} md={5}>
                      <Row className="g-3">
                        <Col xs={12}>
                          <label className="mb-2 w-100">
                            Ingresá la dirección del inmueble{' '}
                            <span className="text-danger">*</span>
                          </label>

                          <InputAddressAutocomplete
                            setMobileGoogle={setMobileGoogle}
                            ready={ready}
                            values={values}
                            setValues={setValues}
                            emptyInput={emptyInput}
                            setEmptyInput={setEmptyInput}
                            name="autocomplete"
                            neighborhoods={neighborhoods}
                          />

                          {errors.street &&
                            errors.number &&
                            (emptyInput ? (
                              <label
                                className="mb-0"
                                style={{ color: '#da1717e8' }}
                              >
                                El campo "dirección" es requerido.
                              </label>
                            ) : (
                              <label
                                className="mb-0"
                                style={{ color: '#da1717e8' }}
                              >
                                La dirección ingresada no corresponde a un
                                domicilio en CABA.
                              </label>
                            ))}

                          {(!errors.street || !errors.number) &&
                            errors.barrios && (
                              <label
                                className="mb-0"
                                style={{ color: '#da1717e8' }}
                              >
                                No hemos podido detectar el barrio. Seleccione
                                uno manualmente para poder continuar.
                              </label>
                            )}
                        </Col>

                        <Col
                          xs={12}
                          className={classNames({
                            'mt-0': !values.lat
                          })}
                        >
                          <Collapse in={!!values.lat}>
                            <div>
                              <label className="mb-2 w-100">
                                Ingresá letra o número si corresponde
                              </label>

                              <Field
                                type="text"
                                name="letter"
                                className="form-control"
                                placeholder="Ej: A, B, 1, 2, etc."
                              />
                            </div>
                          </Collapse>
                        </Col>

                        <Col
                          xs={12}
                          className={classNames({
                            'mt-0': !values.lat
                          })}
                        >
                          <Collapse in={!!values.lat}>
                            <div>
                              <label className="mb-2 w-100">
                                Seleccione el barrio al que pertenece{' '}
                                <span className="text-danger">*</span>
                                <OverlayTrigger
                                  overlay={
                                    <Tooltip
                                      id={`tooltip-top`}
                                      className="small"
                                    >
                                      El sistema le recomendará el barrio al que
                                      pertenece la dirección ingresada, pero
                                      puede modificarlo si lo considera
                                      necesario.
                                    </Tooltip>
                                  }
                                >
                                  <span>
                                    <FiInfo className="ms-2" size={16} />
                                  </span>
                                </OverlayTrigger>
                              </label>

                              <ReactSelect
                                name="barrios"
                                value={
                                  values.barrios?.length
                                    ? {
                                        value: values.barrios[0],
                                        label:
                                          neighborhoods.find(
                                            n => n.value === values.barrios[0]
                                          )?.label ||
                                          '-- Seleccione el Barrio --'
                                      }
                                    : {
                                        value: 0,
                                        label: '-- Seleccione el Barrio --'
                                      }
                                }
                                onChange={e => {
                                  setValues(prev => ({
                                    ...prev,
                                    barrios: [Number(e.value)]
                                  }));
                                }}
                                options={[
                                  {
                                    value: 0,
                                    label: '-- Seleccione el Barrio --'
                                  },
                                  ...neighborhoods
                                ]}
                                isSearchable={false}
                              />
                            </div>
                          </Collapse>
                        </Col>

                        <Col
                          xs={12}
                          className={classNames({
                            'mt-0': !currentNeighborhood?.children
                          })}
                        >
                          <Collapse in={!!currentNeighborhood?.children}>
                            <div>
                              <label className="mb-2 w-100">
                                Seleccione el barrio coloquial
                                <OverlayTrigger
                                  overlay={
                                    <Tooltip
                                      id={`tooltip-top`}
                                      className="small"
                                    >
                                      El sistema le recomendará el barrio al que
                                      pertenece la dirección ingresada, pero
                                      puede modificarlo si lo considera
                                      necesario.
                                    </Tooltip>
                                  }
                                >
                                  <span>
                                    <FiInfo className="ms-2" size={16} />
                                  </span>
                                </OverlayTrigger>
                              </label>

                              <ReactSelect
                                name="barrios"
                                value={
                                  values.barrios
                                    ? {
                                        value: values.barrios[1] || 0,
                                        label:
                                          (values.barrios[1] &&
                                            currentNeighborhood?.children?.find(
                                              n => n.value === values.barrios[1]
                                            )?.label) ||
                                          '-- Seleccione el Barrio Coloquial --'
                                      }
                                    : {
                                        value: 0,
                                        label:
                                          '-- Seleccione el Barrio Coloquial --'
                                      }
                                }
                                onChange={e => {
                                  setValues(prev => ({
                                    ...prev,
                                    barrios: e.value
                                      ? [values.barrios[0], Number(e.value)]
                                      : [values.barrios[0]]
                                  }));
                                }}
                                options={[
                                  {
                                    value: '',
                                    label:
                                      '-- Seleccione el Barrio Coloquial --'
                                  },
                                  ...(currentNeighborhood?.children || []).map(
                                    ({ value, label }) => ({ value, label })
                                  )
                                ]}
                                isSearchable={false}
                              />
                            </div>
                          </Collapse>
                        </Col>

                        <Col
                          xs={12}
                          className={classNames({
                            'mt-0': !values?.street
                          })}
                        >
                          <Collapse in={!!values?.street}>
                            <div>
                              <h5 className="border-bottom pb-2">
                                Domicilio Registrado
                              </h5>
                              <ul className="list-unstyled mb-0">
                                <li>
                                  <strong>Calle:</strong> {values.street}
                                </li>
                                <li>
                                  <strong>Altura:</strong> {values.number}
                                  <OverlayTrigger
                                    overlay={
                                      <Tooltip
                                        id={`tooltip-top`}
                                        className="small"
                                      >
                                        La propiedad se mostrará {values.street}{' '}
                                        {Math.floor(values.number / 10) * 10}
                                      </Tooltip>
                                    }
                                  >
                                    <span>
                                      <FiInfo className="ms-2" size={14} />
                                    </span>
                                  </OverlayTrigger>
                                </li>

                                <li>
                                  <strong>Letra/Número:</strong>{' '}
                                  {values.letter ? ` ${values.letter}` : '-'}
                                </li>

                                <li>
                                  <strong>Barrio:</strong>{' '}
                                  {neighborhoodsObj[values.barrios?.at(-1)] ||
                                    '-'}
                                </li>
                              </ul>
                            </div>
                          </Collapse>
                        </Col>
                      </Row>
                    </Col>

                    <Col
                      className={`google-map ${
                        mobileGoogle ? 'mobileGoogle' : ''
                      } position-relative pt-1`}
                      xs={12}
                      sm={12}
                      md={7}
                    >
                      <GoogleMap
                        className="border"
                        values={values}
                        setValues={setValues}
                        mapStyle=""
                        darkStyle=""
                        zoom={values.lat ? 17 : 11}
                        onReady={() => setReady(true)}
                        center={
                          values.lat && values.lng
                            ? { lat: values.lat, lng: values.lng }
                            : { lat: -34.6106694, lng: -58.4300401 }
                        }
                      />
                    </Col>
                  </Row>

                  <Field
                    type="hidden"
                    name="street"
                    className="form-control-sm w-100"
                    disabled
                  />

                  <Field
                    type="hidden"
                    className="form-control-sm w-100"
                    name="number"
                    disabled
                  />
                  <button
                    onClick={handleClick}
                    hidden
                    ref={yupSubmitRef}
                  ></button>
                </Form>
              );
            }}
          </Formik>
        </>
      )}
    </>
  );
};

export default Ubicacion;
